module.exports = __webpack_public_path__ + "03-thumbnail.jpg?f72a6c45faef49d9ecd3743d0d33c83c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/03-thumbnail.jpg
// module id = 40
// module chunks = 0